import { parseUtcDate } from "../../utils";
import type { AnalyticsModel } from "./utils";

export type EvidenceSelection = {
  traceIndex: number;
  eventIndex: number;
  scope: "run" | "process" | "session";
};
export function evidenceSteps(model: AnalyticsModel, selection: EvidenceSelection) {
  const name = model.processes[selection.traceIndex]?.trace.name;
  return model.processes
    .flatMap((pv, traceIndex) =>
      selection.scope === "session" ||
      (selection.scope === "run" ? traceIndex === selection.traceIndex : pv.trace.name === name)
        ? pv.trace.events.map((event, eventIndex) => ({
            event,
            traceIndex,
            eventIndex,
            processName: pv.trace.name,
          }))
        : [],
    )
    .sort(
      (a, b) =>
        parseUtcDate(a.event.start).getTime() - parseUtcDate(b.event.start).getTime() ||
        a.traceIndex - b.traceIndex ||
        a.eventIndex - b.eventIndex,
    );
}

// Capture filenames use UTC YYYY-MM-DD_HH_MM_SS_mmm. Sorting captures rather
// than step extents preserves chronology when steps/runs interleave.
export function evidenceScreenshots(steps: ReturnType<typeof evidenceSteps>) {
  const entries = steps
    .flatMap(step =>
      (step.event.screenshots ?? []).map(filename => {
        const match = filename.match(/(\d{4}-\d{2}-\d{2})_(\d{2})_(\d{2})_(\d{2})_(\d{3})/);
        const captured = match
          ? Date.parse(`${match[1]}T${match[2]}:${match[3]}:${match[4]}.${match[5]}Z`)
          : NaN;
        return {
          ...step,
          filename,
          time: Number.isFinite(captured) ? captured : parseUtcDate(step.event.start).getTime(),
        };
      }),
    )
    .sort((a, b) => a.time - b.time);
  const seen = new Set<string>();
  return entries.filter(entry => {
    if (seen.has(entry.filename)) return false;
    seen.add(entry.filename);
    return true;
  });
}
